import {ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {GenericModalComponent} from '../../forms/generic-modal/generic-modal.component';

declare var Quagga;

@Component({
  selector: 'vb-mobile-barcode-scanner',
  templateUrl: './mobile-barcode-scanner.component.html',
  styleUrls: ['./mobile-barcode-scanner.component.css']
})
export class MobileBarcodeScannerComponent implements OnInit, OnDestroy {

  @Input()
  formats = ["ean_8_reader"];

  showScanner = false;

  errorMessage: string;

  lastScannedCode: string;
  lastScannedCodeDate: number;

  @ViewChild('scannerModal')
  modal: GenericModalComponent;

  hasCameras = false;
  hasPermission: boolean;

  torchEnabled = false;
  torchAvailable$ = new BehaviorSubject<boolean>(false);

  scannerEnabled: boolean = false;

  availableDevices: MediaDeviceInfo[];
  selectedDevice: MediaDeviceInfo = null;

  @Output()
  eanRecognized: EventEmitter<string> = new EventEmitter();

  constructor(private cd: ChangeDetectorRef) {

  }

  ngOnInit(): void {

  }

  showModal() {
    this.showScanner = true;
    this.cd.detectChanges()
    this.initScanner();
    this.modal.show();
  }

  onModalHide() {
    this.destroyScanner();
    this.showScanner = false;
  }

  initScanner(): void {
    if (!navigator.mediaDevices || !(typeof navigator.mediaDevices.getUserMedia === 'function')) {
      this.errorMessage = 'Das Gerät oder der Browser unterstützt keinen Zugriff auf die Kamera...';
      return;
    }

    this.lastScannedCode = null;
    this.lastScannedCodeDate = null;

    Quagga.init({
      inputStream: {
        name: "Live",
        type: "LiveStream",
        target: document.querySelector('#mobileScanner'),
        constraints: {
          facingMode: 'environment' // restrict camera type
        },
        area: { // defines rectangle of the detection
          top: '40%',    // top offset
          right: '0%',  // right offset
          left: '0%',   // left offset
          bottom: '40%'  // bottom offset
        }
      },
      frequency: 10,
      debug: false,
      decoder: {
        readers: this.formats
      },
      locator: {
        patchSize: "medium",
        halfSample: true
      },
      numOfWorkers: 2
    }, (err) => {
      if (err) {
        this.onScanError(err);
        return;
      }
      Quagga.onDetected(this.onDetectedCallback);
    });

  }

  onDetectedCallback = (result) => {
    this.onBarcodeScanned(result.codeResult.code);
  }

  destroyScanner() {
    if (Quagga) {
      try {
        Quagga.stop();
        Quagga.offDetected(this.onDetectedCallback);
      } catch (e) {
       console.error("No mobile scanner to stop...")
      }
    }
  }

  public enableScanner() {
    if (!this.scannerEnabled) {
      this.lastScannedCodeDate = null;
      this.scannerEnabled = true;
      Quagga.start();
    }
  }

  public disableScanner() {
    if (this.scannerEnabled) {
      this.scannerEnabled = false;
      Quagga.pause();
    }
  }

  onBarcodeScanned(code: string) {
    console.info("Scanned code " + code);
    this.lastScannedCode = code;
    this.disableScanner();
    this.eanRecognized.next(this.lastScannedCode);
  }

  onScanError(err) {
    this.errorMessage = err;
  }

  ngOnDestroy(): void {
    this.destroyScanner();
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/components/mobile-barcode-scanner/mobile-barcode-scanner.component.ts